/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
//
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class AbsencesRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;
    let dateId = params.date_id;
    let periodId = params.period_id;

    return hash({
      students: store.query('person', { type: PersonType.LEARNER }),
      date: store.findRecord('date', dateId),
      // date: Promise.reject({'error: 'You Died'}),
      period: store.findRecord('timetable/period', periodId),
      records: store.query('attendance/record', { dateId }),
    });
  }
}
